import {
    SOCIETY_GET_SHIFT_ENUMS,
    SOCIETY_GET_SHIFTS,
    SOCIETY_GET_SHIFT_DETAILS,
    SOCIETY_CREATE_SHIFT,
    SOCIETY_UPDATE_SHIFT,
    SOCIETY_DELETE_SHIFT,
    SOCIETY_GET_SHIFT_ASSIGNMENTS,
    SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS,
    SOCIETY_CREATE_SHIFT_ASSIGNMENT,
    SOCIETY_UPDATE_SHIFT_ASSIGNMENT,
    SOCIETY_END_SHIFT_ASSIGNMENT,
    SOCIETY_DELETE_SHIFT_ASSIGNMENT,
} from '../../index.types';

// Every mutating action accepts optional onSuccess(data) / onError({ code,
// message, data }) callbacks. The saga invokes them so a screen can branch on
// the machine-readable `code` — SHIFT_IN_USE and ASSIGNMENT_OVERLAP both carry
// the extra fields a recovery dialog needs.

// ---- Shift definitions ----------------------------------------------------

// No permission required. Returns break_types and the labelled weekday list.
export const getShiftEnums = (data) => ({ type: SOCIETY_GET_SHIFT_ENUMS, data });

// data: { is_active?, search?, page?, limit? } (shift.read)
export const getShifts = (data) => ({ type: SOCIETY_GET_SHIFTS, data });

// data: { shift_id }
export const getShiftDetails = (data) => ({ type: SOCIETY_GET_SHIFT_DETAILS, data });

// data: shift fields + callbacks (shift.manage). 409 SHIFT_CODE_TAKEN carries
// `shift_id` so the screen can offer to open the existing shift.
export const createShift = (data) => ({ type: SOCIETY_CREATE_SHIFT, data });

// data: { shift_id, ...changed fields } — omitted fields are left untouched.
// Assignments point at the shift rather than copying its timings, so an edit is
// immediately in force for everyone assigned to it.
export const updateShift = (data) => ({ type: SOCIETY_UPDATE_SHIFT, data });

// data: { shift_id, onSuccess?, onError? } — onError sees SHIFT_IN_USE with an
// `assignments` count; offer "deactivate instead" then.
export const deleteShift = (data) => ({ type: SOCIETY_DELETE_SHIFT, data });

// ---- Assignments ----------------------------------------------------------

// data: { employee_id?, shift_id?, is_active?, active_on?, page?, limit? }
export const getShiftAssignments = (data) => ({ type: SOCIETY_GET_SHIFT_ASSIGNMENTS, data });

// data: { assignment_id }
export const getShiftAssignmentDetails = (data) => ({ type: SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS, data });

// data: { employee_id, shift_id, effective_from, effective_to?, weekly_off_days?,
// notes?, is_active? }. Unlike the employee endpoints this does NOT close an
// existing assignment first — an overlap is a 409 carrying
// `conflicting_assignment`, which is what the recovery dialog needs.
export const createShiftAssignment = (data) => ({ type: SOCIETY_CREATE_SHIFT_ASSIGNMENT, data });

// data: { assignment_id, ...changed fields }. For corrections only — to move
// someone to a different shift, end this one and create the next.
export const updateShiftAssignment = (data) => ({ type: SOCIETY_UPDATE_SHIFT_ASSIGNMENT, data });

// data: { assignment_id, effective_to, onSuccess?, onError? }
export const endShiftAssignment = (data) => ({ type: SOCIETY_END_SHIFT_ASSIGNMENT, data });

// data: { assignment_id, onSuccess?, onError? } — hard delete, for an
// assignment created by mistake.
export const deleteShiftAssignment = (data) => ({ type: SOCIETY_DELETE_SHIFT_ASSIGNMENT, data });
